export default __webpack_public_path__ + "static/media/palm-tree.4a477d6d.png";